// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandler,
    createHandlerChainRunnerOptionalParameter,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import {
    AccountSummaryApiParameter,
    AccountSummaryModel,
    getAccountSummary,
} from "@steiner/App/Services/AccountSummary";

type HandlerType = ApiHandler<AccountSummaryApiParameter & HasOnSuccess, AccountSummaryModel>;

export const defaultParameters = {
    customerSequence: "-1",
    year: "",
    month: "",
};

export const DispatchBeginLoadAccountSummary: HandlerType = props => {
    props.dispatch({
        type: "xAccountSummary/BeginLoadingAccountSummary",
        isLoading: true,
    } as any);
};

export const PopulateApiParameters: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getAccountSummary(props.apiParameter);
    } catch (error) {
        props.dispatch({
            type: "xAccountSummary/FailedLoadingAccountSummary",
        } as any);
        return false;
    }
};

export const DispatchCompleteLoadAccountSummary: HandlerType = props => {
    props.dispatch({
        type: "xAccountSummary/CompleteLoadingAccountSummary",
        value: props.apiResult,
    } as any);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [
    DispatchBeginLoadAccountSummary,
    PopulateApiParameters,
    RequestDataFromApi,
    DispatchCompleteLoadAccountSummary,
    ExecuteOnSuccessCallback,
];

const loadAccountSummary = createHandlerChainRunnerOptionalParameter(chain, defaultParameters, "loadAccountSummary");

export default loadAccountSummary;
